<!-- ä¹¦ç­¾åˆ—è¡¨  ä¹‹ ä¹¦ç­¾å­�ç»„ä»¶  markInfo -->
<template>
    <div  class="" >
        <div class="bookBox" >
     
            <div class="bookName"  >
                <span class="bookNameInfo">
                    <span>{{bookName}}</span>
                </span>  
            </div>

            <div id="markBox">
                <ul>
                    <li v-for="(mark_obj, key) in markList" :key="key">
                       <liBox :id="key" :pageId="mark_obj.emBookPage" :markId="mark_obj.emId"></liBox>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import liBox from '@/components/book_mark/box/li_box.vue'  
export default {
  components: {
      liBox
  },
  props: {
    bookName:String,
    id: Number,
    markInfo:String,  // ä¹¦ç­¾éš�ç¬”å†…å®¹
    bookInfo:String,   // è®°å½•çš„å›¾ä¹¦å†…å®¹  è·³è½¬åˆ°é˜…è¯»ç”¨ï¼ˆå¹¶æ��å�–é‡Œé�¢çš„pageidï¼‰
    markList:Array
  },
  data () {
    return {
        oldBookMarks:this.markInfo,      // æ›´æ–°çš„æ—¶å€™æœ€æ–°çš„å€¼ å’Œæ­¤å€¼å¯¹æ¯”æœ‰è¿‡ä¸�å�Œåˆ™æ›´æ–°åˆ°æ•°æ�®åº“ä¸­
        myBookMarkInfo: this.markInfo,   // èŽ·å�–ä¼ è¿›æ�¥çš„å±žæ€§å€¼   è¿™æ ·æ‰�èƒ½åŠ¨æ€�ç»‘å®šç»„ä»¶
        showTipInfoState: false,
        minName: '',
        home_url: this.isrc,
        srcList: [
             // imgurl + 'view/' + this.id + '/' + this.iname
        ],
        showFavorite: false,
        isAdd: false, // æ˜¯å�¦å·²ç»�è¢«æ·»åŠ åˆ°æ”¶è—�
 
        showTipInfoText: 'èŽ·å�–ä¸­...',
        showTipSubInfoNowIndex: 0,
        showTipInfoIntervalAddress: null
    }
  },
  methods: {
    hideAddFavoriteBn () {
      this.showFavorite = false
    },
    showAddFavoriteBn () {
      if (!this.isAdd) {
        this.showFavorite = true
      }
    },
    openContentInfo () {
      //this.$store.commit('setGlobalObjOfNewsId', this.id)
      //this.$router.push('/advertisementView').catch(() => {})
    },
    delBookMark(id){
        // this.$alert(id)
        // eslint-disable-next-line no-debugger
        debugger
        this.$parent.delMadrkInfoById(id);
    },
    showNewHelloInfo(){
        this.$alert(this.myBookMarkInfo)
    },
    updateBookMark(){
        if(this.oldBookMarks !== this.myBookMarkInfo){
            //this.$alert("å·²ç»�æ”¹è¿‡ ï¼Œå‡†å¤‡æ›´æ–°")
            const api = '/spring/front/user/updatebookmark'
            const params = {
                id:this.id,   //æœ€å¤§åŠ è½½ä¸ªæ•°
                markInfo: this.myBookMarkInfo
            }
       
            //let that = this  //å­˜å‚¨this
            this.axios.post(api, this.$stringify(params)).then(res => {
                // console.log(res.status)
                if (res.status !== 200) {
                    this.$alert("ç½‘ç»œå¼‚å¸¸ï¼Œè¯·é‡�è¯•", 'æ��ç¤º')
                    return
                }
                // eslint-disable-next-line no-debugger
                //debugger
                if (res.data == 1) {  // æ›´æ–°æˆ�åŠŸ
                    //this.$alert("OK", 'æ��ç¤º') 
                }
                else{
                    this.$alert("æ›´æ–°å¤±è´¥ï¼Œæœ�åŠ¡ç«¯æŽ¥æ”¶å�‚æ•°å¼‚å¸¸", 'æ��ç¤º')
                }
            //this.$alert(resMap.info, 'æ��ç¤º')
       })
        } 
    },
    openBook(key) {
        
        // eslint-disable-next-line no-debugger
        debugger

        let book_mark = this.markList[key]

        let mark_info = book_mark.emCateName

        mark_info = mark_info.replace(/^\s*/,"");
      
        let vt = mark_info.split(","); //  alert(node.attributes); alert(vt.length);
		if(vt.length == 14){  //
            //this.$alert(this.bookInfo)

            // è°ƒç”¨é˜…è¯»é¡µé�¢çš„ openReadPan  æ³¨æ„� ç”¨å‡ ä¸ªparent æ‰“åŒ…å�Žå¤šæµ‹ä¸€ä¸‹
            // eslint-disable-next-line no-debugger
            debugger
            this.$parent.$parent.$parent.openParentBook( mark_info)
          /*
          this.$parent.$parent.$parent.parent.openReadPan(vt[0],vt[1],vt[2],vt[3],vt[4],vt[5],vt[6],vt[7],vt[8],vt[9],vt[10],vt[11],vt[12],vt[13]);
          */
 
		}
        
    }
  },
  mounted () {
      /*
        this.minName = this.iname
        if (this.minName.length > 14) {
            this.minName = this.iname.substring(0, 13) + '...'
        }
      
      */
  },
  computed: {
   
    
    imgStyle () {
      return {
        height: this.iHeight + 'px',
        width: "100%"
      }
    },
    pageId: function () {
        let kk = this.bookInfo
        let pageid
        if(kk != null && kk.length > 0){
            let arr1 = kk.split(",")
            if(arr1 != null && arr1.length == 14){
                pageid = arr1[6]
            }
        }
        return  "ç¬¬" + pageid + "é¡µ"
    }
  },
  watch: {

    /*
    showTipInfoState (newV) {
      if (newV) {
        const sourceTitle = this.iname
        // console.log(sourceTitle)
        if (typeof sourceTitle === 'undefined') {
          return
        }
        if (this.showTipInfoIntervalAddress) {
          return
        }
        this.showTipInfoIntervalAddress = setInterval(() => {
          const textMaxLength = 8
          if (sourceTitle.length <= textMaxLength + 1) {
            this.showTipInfoText = sourceTitle
            return
          }
          let subStr = sourceTitle.substr(
            this.showTipSubInfoNowIndex,
            textMaxLength
          )
          if (subStr.length < 1) {
            this.showTipSubInfoNowIndex = 0
            subStr = sourceTitle.substr(
              this.showTipSubInfoNowIndex,
              textMaxLength
            )
          }
          this.showTipInfoText = subStr
          this.showTipSubInfoNowIndex += 1
        }, 300) // æ¯�è¿‡ä¸€ç§’æ”¹ä¸€æ¬¡
      } else {
        const textMaxLength = 8
        clearInterval(this.showTipInfoIntervalAddress)
        this.showTipInfoIntervalAddress = null
        this.showTipSubInfoNowIndex = 0
        this.showTipInfoText = this.iname.substr(
          this.showTipSubInfoNowIndex,
          textMaxLength
        )
      }
    }
    */  
  }
}
</script>
<style scoped>

.bookMarkSpan {
    width:250px; 
    height:270px;
    background: transparent;
    border: 0px;
    font-size: 18px;
    line-height: 30px;
    text-indent: 2em; /*é¦–è¡Œç¼©è¿›*/
}

.introductionInfoClass i{
    font-size: 40px;
    color: #fff;
}
.bookBox{
    width: 280px;
    height: 461px;
    position: relative;
    padding-top: 60px;

    background-image: url(/static/images/researchroom/bookmark_bg.png);
    background-repeat:no-repeat;
 
}

.bookMark{
    width: 100%;
    padding: 10px;
    height: auto;
}

.bookName{
    width: 100%;
    height: 40px;
    cursor: pointer;
    font-size: 20px;
    font-weight: 600;
    
    display: flex;
    flex-direction: column;
    justify-content:start;
  
}


.bookPage{
    width: 100%;
    height: 30px;
    text-align: right;
    padding-right: 40px;
    color: #222;
    font-size: 14px;
}

.bookNameInfo{
    display: inline-block;
    width: 100%;
    height: 40px;
}

#markBox span:hover{
     display: inline-block;
     position: relative;
     top: 1px;
     color: brown;
}


.el-icon-error{
    color: brown;
    font-size: 30px;
}



.ibox {
  width: 100%;
 
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  border: 0px solid #963;
  position: relative;
  background-color: transparent;
}

.iname {
  width: 100%;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
  font-size: 15px;
  margin-bottom: 0px;
}

.iimgC {
  height: 100%;
  text-align: center;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
}

.iimgC img {
  cursor: pointer;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}

#addFavor {
  position: absolute;
  right: 12px;
  top: 6px;
  cursor: pointer;
  font-size: 30px; /*æŽ§åˆ¶ui å›¾æ ‡çš„å¤§å°�*/
}

.el-image {
  position: relative;
  display: block;
}
.introductionInfoClass {

  color: brown;
 
 
  /**ç»™å›¾ç‰‡åŠ æ��è¿°ä¿¡æ�¯çš„é˜´å½± */
  z-index: 100;
  width: 40px;
  height: 40px;
 
  position: absolute;
  top: 10px;
  right: -10px;
  font-size: 40px;
  cursor: pointer;
 
  /*
  box-shadow: inset 0px 29px 2px rgba(15, 13, 13, 0.616);
  */
  
}
.contentFlowClass {
  /*ç»™æ��è¿°ä¿¡æ�¯çš„æ–‡å­—è®¾ç½®å±žæ€§  */
  width: 100%;
  display: inline-block;
  font-size: 12px;
  color: #fff;
  line-height: 10px;
}

#markBox{
    height: 350px;
    overflow-y: auto;
}

#markBox ul li{
    list-style-type: none;
    text-align: left;
    line-height: 30px;
    cursor: pointer; 
}
</style>
